import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function WeekText({ data }) {
  const [popupImage, setPopupImage] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.weekId) {
      const el = document.getElementById(`week-${location.state.weekId}`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);

  const openImage = (path) => setPopupImage(path);
  const closePopup = () => setPopupImage(null);

  return (
    <div className="week__table">
      {[...data].reverse().map((block) => (
        <div key={block.id} id={`week-${block.id}`} className="week__blank">
          <h4 className="week__title">
            <li className="week__content">{block.title}</li>
          </h4>

          <section>
            <div className="week__images">
              {block.images?.map((img, idx) => (
                <img
                  key={idx}
                  src={img.path}
                  alt={img.alt}
                  className="week__image"
                  onClick={() => openImage(img.path)}
                />
              ))}
            </div>

            {block.files.map((file, index) => (
              <div key={index} className="licenses__blank-link">
                <h3 className="weektext__title">{file.label}</h3>
                <a
                  href={file.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="structure__download-link licenses__link"
                >
                  📄 Прочитать
                </a>
              </div>
            ))}
          </section>
        </div>
      ))}

      {popupImage && (
        <div className="popup" onClick={closePopup}>
          <img src={popupImage} alt="Просмотр" className="popup__image" />
        </div>
      )}
    </div>
  );
}
